import ConnectedSiteSearch from "@/components/layout/connected-site-search";
import { isSupportedLocale } from "@/i18n-locales";
import { routeKeyFromSlug } from "@/lib/routes";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router";

export default function SiteSearchBand() {
  const { t } = useTranslation("common");
  const { lng } = useParams<{ lng: string }>();
  const locale = isSupportedLocale(lng) ? lng : "it";
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  const routeKey = routeKeyFromSlug(segments[1] ?? "", locale);

  // The dedicated results page contains its own autocomplete field.
  if (routeKey === "search") return null;

  return (
    <section
      data-site-search-band
      aria-labelledby="site-search-band-title"
      className="border-b border-border/60 bg-muted/15"
    >
      <div className="mx-auto max-w-5xl px-4 py-2 sm:px-6 lg:px-8">
        <h2 id="site-search-band-title" className="sr-only">
          {t("search.label")}
        </h2>
        <div className="grid gap-2 rounded-2xl border border-border bg-background/80 p-2.5 shadow-sm sm:grid-cols-[minmax(10rem,0.55fr)_minmax(18rem,1.45fr)] sm:items-center sm:gap-4 sm:px-3">
          <div className="hidden sm:block">
            <p className="font-display text-sm font-semibold uppercase tracking-wide">
              {t("search.label")}
            </p>
            <p className="mt-0.5 text-xs text-muted-foreground">
              {t("search.footer_hint")}
            </p>
          </div>
          <ConnectedSiteSearch locale={locale} />
        </div>
      </div>
    </section>
  );
}
